import React, { useState, useEffect } from 'react';
import api from '../utils/api';

/**
 * Minimal iframe page shown on 3rd-party sites.
 * No Layout — just a small badge card with a "Claim" button.
 * Usage: <iframe src="https://cyqr.ca/embed/badge/badge-code" width="300" height="130" frameborder="0"></iframe>
 */
const EmbedBadge = () => {
  const code = window.location.pathname.split('/embed/badge/')[1];
  const [badge, setBadge] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!code) { setError(true); setLoading(false); return; }
    api.get(`/badges/public/${code}`)
      .then(res => setBadge(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [code]);

  const handleClaim = () => {
    const claimUrl = `${window.location.origin}/claim-badge/${code}`;
    window.open(claimUrl, '_blank', 'noopener,noreferrer');
  };

  const iconIsUrl = badge?.icon_url && badge.icon_url.startsWith('http');

  if (loading) {
    return (
      <div style={{ background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '130px', fontFamily: 'monospace' }}>
        <div style={{ color: '#C5A52A', fontSize: '12px' }}>Loading...</div>
      </div>
    );
  }

  if (error || !badge) {
    return (
      <div style={{ background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '130px', fontFamily: 'monospace' }}>
        <div style={{ color: '#555', fontSize: '12px' }}>Badge not found</div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1400 100%)',
      border: '1px solid #C5A52A33',
      borderRadius: '8px',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      height: '106px',
      boxSizing: 'border-box',
      fontFamily: 'system-ui, sans-serif',
      overflow: 'hidden'
    }}>
      {/* Badge icon */}
      <div style={{ flexShrink: 0 }}>
        {iconIsUrl
          ? <img src={badge.icon_url} alt={badge.name} style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
          : <span style={{ fontSize: '36px', lineHeight: 1 }}>{badge.icon_url || '🏅'}</span>
        }
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#C5A52A', fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '2px', fontFamily: 'monospace' }}>
          CYQR.CA BADGE
        </div>
        <div style={{ color: '#fff', fontSize: '13px', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {badge.name}
        </div>
        {badge.reward_points > 0 && (
          <div style={{ color: '#22C55E', fontSize: '11px', fontFamily: 'monospace', marginBottom: '6px' }}>
            +{badge.reward_points} pts
          </div>
        )}
        <button
          onClick={handleClaim}
          data-testid="embed-claim-button"
          style={{
            background: '#C5A52A',
            color: '#000',
            border: 'none',
            borderRadius: '4px',
            padding: '4px 12px',
            fontSize: '11px',
            fontWeight: 'bold',
            cursor: 'pointer',
            letterSpacing: '0.5px',
            marginTop: '2px'
          }}
        >
          Claim on CYQR.CA
        </button>
      </div>
    </div>
  );
};

export default EmbedBadge;
